import { UNASSIGNED_VALUE as GLOBAL_UNASSIGNED_VALUE } from 'modules/common/smartComponents/const';

export const UNASSIGNED_VALUE = GLOBAL_UNASSIGNED_VALUE;
